import { DateValue } from '@internationalized/date';
import {
  NetPayForAccountInput,
  PaymentMethod,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';
import { anyDateToISOString } from '~/shared/utils/dateTime';

export type NetPayParams = {
  accountId: string;
  paymentMethod: PaymentMethod;
  financialAccountId: string;
  transactionDate: DateValue;
  checkFacilityId?: string | null;
  checkNumber?: string | null;
  checkMemo?: string | null;
  achNumber?: string | null;
  wireNumber?: string | null;
};

export const netPayAtom = createMutationAtomFactory(
  'finance.netPay',
  (params: NetPayParams) => {
    const input: NetPayForAccountInput = {
      accountId: params.accountId,
      financialAccountId: params.financialAccountId,
      paymentMethod: params.paymentMethod,
      transactionDate: anyDateToISOString(params.transactionDate) ?? '',
    };
    if (params.checkFacilityId) {
      input.checkFacilityId = params.checkFacilityId;
    }
    if (params.checkNumber) {
      input.checkNumber = params.checkNumber;
    }
    if (params.checkMemo) {
      input.checkMemo = params.checkMemo;
    }
    if (params.achNumber) {
      input.achNumber = params.achNumber;
    }
    if (params.wireNumber) {
      input.wireNumber = params.wireNumber;
    }

    return {
      financeNetPay: {
        __args: {
          input,
        },
        payment: {
          id: true,
          documentNumber: true,
          status: true,
          amount: {
            amount: true,
            currencyCode: true,
          },
          paymentMethod: true,
          transactionDate: true,
          timestamps: {
            createdAt: true,
            updatedAt: true,
          },
        },
        payableTotal: {
          amount: true,
          currencyCode: true,
        },
        receivableTotal: {
          amount: true,
          currencyCode: true,
        },
        netAmount: {
          amount: true,
          currencyCode: true,
        },
        belowWarningThreshold: true,
      },
    };
  },
);
